export default __webpack_public_path__ + "static/media/card-profile5-square.cdde7ab8.jpg";